
import React from 'react';
import { currencyFormat, displayPan } from "../../../../../helpers/utilities";
import moment from 'moment';
import { SalesLines } from "./inc/SalesComponentsEX01";
import FileUpload from "../../FileUpload";

export const EX01 = React.forwardRef((props, ref) => {
    const { businessDetails, details, preview, proformaPreview, copy } = props;

    const address = (details) => {
        let address = details?.address || details?.address1 || '';
        address += address !== '' ? ', ' : '';
        address += details?.area && details?.area?.name ? details?.area?.name : '';
        return address;
    }

    const address1 = (details) => {
        let address = details?.city && details?.city?.name ? details?.city?.name + ' - ' : '---';
        address += details?.pincode && details?.pincode?.code ? details?.pincode?.code : '---';
        address += details?.state && details?.state?.name ? ', ' + details?.state?.name : '---';
        address += details?.country && details?.country?.name ? ', ' + details?.country?.name : '---';
        return address;
    }

    const discountAmount = (items) => {
        const safeItems = items ?? [];
        if (!safeItems.length) return 0;
        let totalDiscount = Number(details?.cashDiscountAmount || 0);
        for (const v of items) {
            const qty = Number(v.quantity || 0);
            const price = Number(v.pricePerUnit || 0);
            const discountAmt = Number(v.discountAmount || 0);
            const discountPercent = Number(v.discountPercent || 0);

            // Line-level fixed discount
            totalDiscount += discountAmt;

            // Percentage discount
            const percentDiscount = ((qty * price) * discountPercent) / 100;

            if (v.amount < 0) {
                totalDiscount -= percentDiscount;
            } else {
                totalDiscount += percentDiscount;
            }
        }

        return Number(totalDiscount.toFixed(2));
    }
    return (
        <div className="sbp_bill" style={{ maxWidth: 980, margin: "auto", fontFamily: "Roboto" }}>
            <div>
                <div style={{ width: "100%", padding: 10, backgroundColor: "#1c314c" }} />
                <div style={{ padding: "10px 12px", position: "relative", marginTop: 5, backgroundColor: "#ffc27a", display: "flex" }}>
                    {
                        proformaPreview ? <div style={{ color: "#000000", width: "55%", display: "inline-block", lineHeight: "1.5715", fontSize: 20, fontWeight: 500, textAlign: "right" }}>
                            Estimate
                        </div> : <div style={{ color: "#000000", width: "55%", display: "inline-block", lineHeight: "1.5715", fontSize: 20, fontWeight: 500, textAlign: "right" }}>
                            {
                                copy ? 'Purchase Order' : 'Request For Quotation'
                            }
                            {
                                details?.supply_quote_status === 'CANCELLED' ? ' - Cancelled' : ''
                            }
                        </div>
                    }
                </div>
            </div>
            <div style={{ border: "1px solid #000000", borderTop: "none" }}>
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                    {
                        (details?.business?.logoUri || businessDetails?.logoUri) &&
                        <div style={{ width: '20%', display: 'inline-block', padding: '0 7px', position: 'relative' }}>
                            <FileUpload
                                filePath={details?.business?.logoUri || businessDetails?.logoUri || ''}
                                view={true}
                            />
                        </div>
                    }
                    <div style={{ width: (details?.business?.logoUri || businessDetails?.logoUri) ? '80%' : '100%', display: 'inline-block' }}                    >
                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                            {/* Registered Address */}
                            <div style={{ width: '50%', display: 'inline-block', borderRight: '1px solid #000', padding: '12px' }}>
                                <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                    Registered Address
                                </h6>
                                <p style={{ lineHeight: "1.22", color: "#000", fontWeight: 500, fontSize: 19 }}>
                                    {details?.business?.name || businessDetails?.businessName || '---'}
                                </p>
                                <p style={{ marginTop: 10, color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                    {address(details?.business || businessDetails)}
                                </p>
                                <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }} >
                                    {address1(details?.business || businessDetails)}
                                </p>
                            </div>

                            {/* Shipped To */}
                            <div style={{ width: '50%', display: 'inline-block', padding: '12px' }}>
                                <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                    Shipped To
                                </h6>
                                <p style={{ lineHeight: "1.22", color: "#000", fontWeight: 500, fontSize: 19 }}>
                                    {details?.business?.name || businessDetails?.businessName || '---'}
                                </p>
                                <p style={{ marginTop: 10, color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                    {address(details)}
                                </p>
                                <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }} >
                                    {address1(details)}
                                </p>
                            </div>
                        </div>

                        {/* Contact Details */}
                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                            {/* Left */}
                            <div style={{ width: '50%', display: 'inline-block', borderRight: '1px solid #000', padding: '12px' }}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex' }}>
                                        <h6 style={{ width: '17%', color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>Email</h6>
                                        <p style={{ width: '83%', color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>{details?.business?.email || businessDetails?.email || '---'}</p>
                                    </div>
                                </div>

                                <div style={{ width: '50%' }}>
                                    <div style={{ display: 'flex' }}>
                                        <h6 style={{ width: '35%', color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>Ph No.</h6>
                                        <p style={{ width: '65%', color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>{details?.business?.mobile || businessDetails?.mobile || '---'}</p>
                                    </div>
                                </div>

                                {details?.business?.panNumber && (
                                    <div style={{ width: '50%' }}>
                                        <div style={{ display: 'flex' }}>
                                            <h6 style={{ width: '25%', color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                                {displayPan(details.business.panNumber || businessDetails?.pan)[0]}
                                            </h6>
                                            <p style={{ width: '75%', wordBreak: 'break-all', color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                                {displayPan(details.business.panNumber || businessDetails?.pan)[1]}
                                            </p>
                                        </div>
                                    </div>
                                )}

                                {details.includeGst && (
                                    <div style={{ width: '100%' }}>
                                        <div style={{ display: 'flex' }}>
                                            <h6 style={{ width: '17%', color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>GSTIN</h6>
                                            <p style={{ width: '83%', color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>{details?.business?.gstNumber || businessDetails?.gst || '---'}</p>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Right (duplicate kept exactly) */}
                            <div style={{ width: '50%', display: 'inline-block', padding: '12px' }}>
                                <div style={{ display: 'flex' }}>
                                    <h6 style={{ width: '17%', color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>Email</h6>
                                    <p style={{ width: '83%', color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>{details?.business?.email || businessDetails?.email || '---'}</p>
                                </div>

                                <div style={{ width: '50%' }}>
                                    <div style={{ display: 'flex' }}>
                                        <h6 style={{ width: '35%', color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>Ph No.</h6>
                                        <p style={{ width: '65%', color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>{details?.business?.mobile || businessDetails?.mobile || '---'}</p>
                                    </div>
                                </div>

                                {details?.business?.panNumber && (
                                    <div style={{ width: '50%' }}>
                                        <div style={{ display: 'flex' }}>
                                            <h6 style={{ width: '25%', fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                                {displayPan(details.business.panNumber || businessDetails?.pan)[0]}
                                            </h6>
                                            <p style={{ width: '75%', wordBreak: 'break-all', color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                                {displayPan(details.business.panNumber || businessDetails?.pan)[1]}
                                            </p>
                                        </div>
                                    </div>
                                )}

                                {details.includeGst && (
                                    <div style={{ width: '100%' }}>
                                        <div style={{ display: 'flex' }}>
                                            <h6 style={{ width: '17%', fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>GSTIN</h6>
                                            <p style={{ width: '83%', color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>{details?.business?.gstNumber || businessDetails?.gst || '---'}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Supplier Section */}
                <div style={{ borderTop: '1px solid #000', padding: '12px 12px 5px' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div style={{ width: '60%' }}>
                            <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>Supplier</h6>
                            <h1 style={{ lineHeight: "1.22", color: "#000", fontWeight: 500, fontSize: 19 }}>{details?.supplier?.name || '---'}</h1>
                            <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>{address(details?.supplier)}</p>
                            <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>{address1(details?.supplier)}</p>
                        </div>
                        <div style={{ width: '40%' }}>
                            <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>{copy ? 'Order' : 'Quotation'} Number</h6>
                            <h1 style={{ lineHeight: "1.22", color: "#000", fontWeight: 500, fontSize: 19 }}>{details?.serialNo || '---'}</h1>
                            <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>Created By</h6>
                            <p style={{ lineHeight: "1.22", color: "#000", fontWeight: 500, fontSize: 19 }}>{details?.quoteCreatedBy || '---'}</p>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginTop: 20 }}>
                        {/* Left Section */}
                        <div style={{ width: '60%', display: 'inline-block' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>

                                {/* Email */}
                                <div style={{ width: '100%', display: 'block' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                        <div style={{ width: '13%', display: 'inline-block', verticalAlign: 'middle' }}>
                                            <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                                Email
                                            </h6>
                                        </div>
                                        <div style={{ width: '87%', display: 'inline-block', verticalAlign: 'middle' }}>
                                            <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                                {details?.supplier?.email || '---'}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Phone */}
                                <div style={{ width: '50%', display: 'inline-block' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                        <div style={{ width: '27%', display: 'inline-block', verticalAlign: 'middle' }}>
                                            <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                                Ph No.
                                            </h6>
                                        </div>
                                        <div style={{ width: '73%', display: 'inline-block', verticalAlign: 'middle' }}>
                                            <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                                {details?.supplier?.mobile || '---'}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* GSTIN */}
                                {details.includeGst && (
                                    <div style={{ width: '50%', display: 'inline-block' }}>
                                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                            <div style={{ width: '27%', display: 'inline-block', verticalAlign: 'middle' }}>
                                                <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                                    GSTIN
                                                </h6>
                                            </div>
                                            <div style={{ width: '73%', display: 'inline-block', verticalAlign: 'middle' }}>
                                                <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                                    {details?.supplier?.gstin || '---'}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* PAN */}
                                {details?.supplier?.pan && (
                                    <div style={{ width: '100%', display: 'block' }}>
                                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                            <div style={{ width: '13%', display: 'inline-block', verticalAlign: 'middle' }}>
                                                <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                                    {displayPan(details.supplier.pan)[0]}
                                                </h6>
                                            </div>
                                            <div style={{ width: '87%', display: 'inline-block', verticalAlign: 'middle' }}>
                                                <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                                    {displayPan(details.supplier.pan)[1]}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>

                        {/* Right Section */}
                        <div style={{ width: '40%', display: 'inline-block'}}>
                            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>

                                <div style={{ width: '50%', display: 'inline-block' }}>
                                    <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                        Date
                                    </h6>
                                    <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                        {details?.transactionDate
                                            ? moment(details.transactionDate).format('DD MMM YYYY')
                                            : '---'}
                                    </p>
                                </div>

                                <div style={{ width: '50%', display: 'inline-block', textAlign: 'right' }}>
                                    <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                        Delivery Date
                                    </h6>
                                    <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                        {details?.deliveryDate
                                            ? moment(details.deliveryDate).format('DD MMM YYYY')
                                            : '---'}
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ borderTop: "1px solid #000000", padding: 12 }}>
                    <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                        <div style={{ width: "25%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                {copy ? 'Order' : 'Quotation'} Number
                            </h6>
                            <h2 style={{ color: "#000", fontSize: 18, fontWeight: 500, marginBottom: 0, lineHeight: "1.22" }}>
                                {details?.serialNo || '---'}
                            </h2>
                        </div>
                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                Req. Rec. Date
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 0, display: "block" }}>
                                {
                                    preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.deliveryDate ? moment(details.deliveryDate).format('DD MMM YYYY') : '---'
                                }
                            </p>
                        </div>
                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }} >
                                Valid Date
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 0, display: "block" }}>
                                {
                                    preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.validDate ? moment(details.validDate).format('DD MMM YYYY') : '---'
                                }
                            </p>
                        </div>
                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                Invoice Amount
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 0, display: "block" }}>
                                {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : `${currencyFormat(details?.invoiceAmount ? details?.invoiceAmount : 0)}`}
                            </p>
                        </div>
                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                Net Amount
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 0, display: "block" }}>
                                {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : `${currencyFormat(details?.assessableValue || (details?.supplyQuoteLineItems ? details?.invoiceAmount - (details?.roundOffAmount || 0) - details?.supplyQuoteLineItems.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0) : 0))}`}
                            </p>
                        </div>
                        {
                            details?.roundOffAmount !== 0 ? <div style={{ width: "10%", padding: "0 3px" }}>
                                <h6
                                    style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                    Round Off
                                </h6>
                                <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 0, display: "block" }}>
                                    {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.roundOffAmount}
                                </p>
                            </div> : ''
                        }

                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                GST Amount
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 0, display: "block" }}>
                                {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : `${currencyFormat(details?.supplyQuoteLineItems ? details?.supplyQuoteLineItems.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0) : 0)}`}
                            </p>
                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", marginTop: 15 }}>
                        <div style={{ width: "25%", padding: "0 3px" }}>
                            {
                                details?.reference ? <>
                                    <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                        Reference
                                    </h6>
                                    <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, marginBottom: 0, lineHeight: "1.15", display: "block" }}>
                                        {details?.reference || '---'}
                                    </p></> : ''
                            }
                        </div>
                        {
                            (details?.fromDate || details?.toDate) &&
                            <div style={{ width: "25%", padding: "0 3px" }}>
                                <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                    Service Date
                                </h6>
                                <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, marginBottom: 0, lineHeight: "1.15", display: "block" }}>
                                    {details.fromDate && moment(details.fromDate).format('DD MMM YYYY')}{details.toDate && (details.toDate !== details.fromDate) && ` to ${moment(details.toDate).format('DD MMM YYYY')}`}
                                </p>
                            </div>
                        }
                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                Place of Supply
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, marginBottom: 0, lineHeight: "1.15", display: "block" }}>
                                {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : businessDetails?.state?.name || details?.business?.state?.name || '---'}
                            </p>
                        </div>
                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                Pmt. Method
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, marginBottom: 0, lineHeight: "1.15", display: "block" }}>
                                {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.mop?.method || '---'}
                            </p>
                        </div>
                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                Currency
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, marginBottom: 0, lineHeight: "1.15", display: "block" }}>
                                {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.currency?.name || '---'}
                            </p>
                        </div>
                        {
                            discountAmount(details?.supplyQuoteLineItems) > 0 &&
                            <div style={{ width: "12.5%", padding: "0 3px" }}>
                                <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                    Total Discount
                                </h6>
                                <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, marginBottom: 0, lineHeight: "1.15", display: "block" }}>
                                    {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : `${currencyFormat(discountAmount(details?.supplyQuoteLineItems))}`}
                                </p>
                            </div>
                        }
                    </div>
                </div>
                {
                    (details?.dispatchDetails || details?.comments) &&
                    <div style={{ display: "flex", borderTop: "1px solid #000000" }}>
                        {
                            details?.dispatchDetails ? <div style={{ width: "30%", padding: "10px 15px 3px" }}>
                                <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }} >
                                    Dispatch Details
                                </h6>
                                <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                    {details?.dispatchDetails || '---'}
                                </p>
                            </div> : ''
                        }
                        {
                            details?.comments ?
                                <div style={{ width: details?.dispatchDetails ? "70%" : "100%", padding: "10px 15px 3px", borderLeft: "1px solid #000000" }}>
                                    <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                        Comments
                                    </h6>
                                    <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                        {details?.comments || '---'}
                                    </p>
                                </div> : ''
                        }
                    </div>
                }
                <SalesLines ref={ref} {...props} terms={true} />
            </div>
        </div >
    )
})